<div class="px-5 py-3 global-alert" *ngIf="error">
  {{ 'globalError.message' | translate }}
  <span class="reload-btn" href="" (click)="reload()">
    {{ 'globalError.reloadBtn' | translate }}
  </span>
  <fa-icon [icon]="faTimes" class="close-btn" (click)="close()"></fa-icon>
</div>